import {
	IOrderDetails,
	IOrderListRequest,
	OrderFilterModel,
	OrderStatusCode,
} from "../../../models/IOrder";
import api from "../../api";

/**
 * Busca a lista de pedidos que atendem aos filtros
 * @returns
 */
export const getOrders = async (withFilters: OrderFilterModel) => {
	const { data } = await api.get(`/manager/order`, { params: withFilters });

	return data as IOrderListRequest;
};

/**
 * Busca informações detalhadas de um pedido
 * @param orderId a ID do pedido a ser carregado
 * @returns os detalhes do pedido
 */
export const getOrder = async (orderId: string) => {
	const { data } = await api.get(`/manager/order/${orderId}`);

	return data as IOrderDetails;
};

/**
 * Altera o status de um pedido
 * @param orderId a ID do pedido a ser atualizado
 * @param body código do novo status do pedido
 * @returns o pedido resultado da operação
 */
export const updateOrder = async (
	orderId: number,
	body: any
) => {
	const { data } = await api.patch(`/manager/order/${orderId}`, body);
	return data;
};


/**
 * Altera o status de um pedido
 * @param orderId a ID do pedido a ser atualizado
 * @param targetStatusCode código do novo status do pedido
 * @returns o pedido resultado da operação
 */
export const updateOrderStatus = async (
	orderId: number,
	targetStatusCode: OrderStatusCode
) => {
	const { data } = await api.patch(`/manager/order/${orderId}`, {
		order_status: targetStatusCode,
	});

	return data;
};
/**
 * Altera o status de vários pedidos
 * @param orderId as IDs dos pedidos a serem atualizados
 * @param targetStatusCode código do novo status dos pedidos
 * @returns os pedidos alterados
 */
export const batchUpdateOrderStatus = async (
	orderIds: number[],
	targetStatusCode: OrderStatusCode
) => {
	const { data } = await api.post(`/manager/order/batch`, {
		id: orderIds,
		status: targetStatusCode,
	});

	return data;
};

/**
 * Adiciona um arquivo como nota fiscal de em pedido, ou remove o existente quando passada uma string vazia
 * @param orderId ID do pedido
 * @param invoice Arquivo da nota fiscal, ou string vazia
 * @returns O pedido resultado da operação
 */
export const updateOrderFileUpload = async (
	orderId: number,
	field: string,
	file: File | string
) => {
	let formData = new FormData();
	formData.append(field, file);

	const { data } = await api.patch(`/manager/order/${orderId}`, formData);

	return data;
};

/**
 * Remove um pedido da listagem
 * @param orderId a ID do pedido a ser removido
 */
export const deleteOrder = async (orderId: number) => {
	const { data } = await api.delete(`/manager/order/${orderId}`);

	return data;
};
/**
 * Remove vários pedidos da listagem
 * @param orderId as IDs dos pedidos a serem removidos
 */
export const batchDeleteOrder = async (orderId: number[]) => {
	const { data } = await api.delete(`/manager/order/batch`, {
		data: { id: orderId },
	});

	return data;
};

/**
 * Adiciona produtos ao pedidos
 * @param orderId 
 * @param params 
 * @returns 
 */
export const addOrderItems = async (orderId: number, params: any) => {
	const { data } = await api.patch(`/manager/order/${orderId}/items`, params);
	return data;
}


export const removeOrderItem = async (itemId:number) => {
	const { data } = await api.delete(`/manager/order_item/${itemId}`);
	return data;
}
